/* cs-cart-confetti.js — Brand confetti burst from both sides when free shipping bar fills */
(function () {
  'use strict';

  var COLORS = ['#d2cc39', '#62679B', '#184B4F'];
  var THRESHOLD_CENTS = 50000; // ₹500 in paise — overridden by data-cs-conf-threshold
  var lastTotal = null;
  var lastBurst = 0;
  var dlg = null, cvs = null, ctx = null, pieces = [], raf = null;

  /* ── Core crossing check — called whenever cart total is known ── */
  function checkCrossing(newTotal) {
    if ((lastTotal === null || lastTotal < THRESHOLD_CENTS) && newTotal >= THRESHOLD_CENTS) {
      setTimeout(burst, 700); // 700ms lets the cart drawer finish opening
    }
    lastTotal = newTotal;
  }

  /* ── Re-fetch real cart total after a cart mutation ── */
  function refreshAndCheck() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (d) { checkCrossing(d.total_price || 0); })
      .catch(function () {});
  }

  /* ── Intercept fetch — catches xo-webcomponents /cart/add.js calls ── */
  function interceptFetch() {
    var orig = window.fetch;
    window.fetch = function (resource, opts) {
      var url = typeof resource === 'string' ? resource
        : (resource instanceof Request ? resource.url : '');
      var p = orig.apply(this, arguments);
      if (/\/cart\/(add|change|update)/.test(url)) {
        p.then(function () { refreshAndCheck(); }).catch(function () {});
      }
      return p;
    };
  }

  /* ── Intercept XHR — fallback for any non-fetch cart calls ── */
  function interceptXHR() {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (/\/cart\/(add|change|update)/.test(url || '')) {
        this.addEventListener('load', function () { refreshAndCheck(); });
      }
      return origOpen.apply(this, arguments);
    };
  }

  /* ── DOM observer — secondary fallback watching xo-cart-will-change ── */
  function watchDom() {
    function attach(el) {
      var raw = parseInt((el.textContent || '').trim(), 10);
      if (isNaN(raw)) raw = parseInt(el.getAttribute('xo-total-price') || '', 10);
      if (!isNaN(raw) && lastTotal === null) lastTotal = raw; // baseline only, no burst

      new MutationObserver(function () {
        var v = parseInt((el.textContent || '').trim(), 10);
        if (isNaN(v)) v = parseInt(el.getAttribute('xo-total-price') || '', 10);
        if (!isNaN(v)) checkCrossing(v);
      }).observe(el, {
        childList: true, characterData: true, subtree: true,
        attributes: true, attributeFilter: ['xo-total-price']
      });
    }

    var el = document.querySelector(
      'xo-cart-will-change[xo-unique-id="xo-cart-free-shipping-checking-inner"]'
    );
    if (el) { attach(el); return; }

    new MutationObserver(function (_, obs) {
      var found = document.querySelector(
        'xo-cart-will-change[xo-unique-id="xo-cart-free-shipping-checking-inner"]'
      );
      if (found) { obs.disconnect(); attach(found); }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    var root = document.querySelector('xo-cart-free-shipping-custom');
    if (root && root.dataset.csConfThreshold) {
      var t = parseInt(root.dataset.csConfThreshold, 10);
      if (!isNaN(t) && t > 0) THRESHOLD_CENTS = t;
    }

    /* Set baseline — read current cart total without triggering confetti */
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (d) { if (lastTotal === null) lastTotal = d.total_price || 0; })
      .catch(function () { if (lastTotal === null) lastTotal = 0; });

    interceptFetch();
    interceptXHR();
    watchDom();
  }

  /* ── Dialog + Canvas ──
     <dialog showModal()> renders in the CSS "top layer" — above everything:
     transforms, z-index, Shopify bar, third-party overlays. Nothing beats it. */
  function ensureDialog() {
    if (dlg) return;
    var style = document.createElement('style');
    style.textContent = '.cs-conf-dlg::backdrop{display:none!important;background:transparent!important;}' +
      '.cs-conf-dlg{background:transparent!important;border:none!important;padding:0!important;margin:0!important;position:fixed!important;inset:0!important;width:100%!important;height:100%!important;max-width:100vw!important;max-height:100vh!important;overflow:hidden!important;pointer-events:none!important;}';
    document.head.appendChild(style);
    dlg = document.createElement('dialog');
    dlg.className = 'cs-conf-dlg';
    cvs = document.createElement('canvas');
    cvs.style.cssText = 'display:block;width:100%;height:100%;pointer-events:none;';
    dlg.appendChild(cvs);
    document.body.appendChild(dlg);
    ctx = cvs.getContext('2d');
  }

  /* ── Particle ── */
  function Piece(fromLeft) {
    var W = window.innerWidth;
    var H = document.documentElement.clientHeight || window.innerHeight;
    var isMobile = W < 600;
    this.x = fromLeft ? W * 0.06 : W * 0.94;
    this.y = H;
    this.color = COLORS[Math.floor(Math.random() * COLORS.length)];
    var scale = isMobile ? 0.8 : Math.max(0.8, W / 1200);
    this.w = (9 + Math.random() * 11) * scale;
    this.h = (4 + Math.random() * 5) * scale;
    var base = fromLeft ? -72 : -108;
    var spread = isMobile ? 100 : 60;
    var angle = (base + (Math.random() - 0.5) * spread) * Math.PI / 180;
    var speed = isMobile
      ? (11 + Math.random() * 11)
      : (14 + Math.random() * 14) * Math.max(0.8, W / 1200);
    this.vx = Math.cos(angle) * speed;
    this.vy = Math.sin(angle) * speed;
    this.gravity = isMobile ? 0.28 : 0.38 * Math.max(0.8, W / 1200);
    this.rot = Math.random() * Math.PI * 2;
    this.rotV = (Math.random() - 0.5) * 0.2;
    this.alpha = 1;
    this.tick = 0;
    this.maxTick = isMobile ? 80 + Math.floor(Math.random() * 40) : 110 + Math.floor(Math.random() * 70);
    this.shape = Math.random() < 0.3 ? 'circle' : 'rect';
  }

  Piece.prototype.step = function () {
    this.vy += this.gravity;
    this.x += this.vx;
    this.y += this.vy;
    this.rot += this.rotV;
    this.tick++;
    var fadeStart = this.maxTick * 0.7;
    this.alpha = this.tick < fadeStart
      ? 1
      : Math.max(0, 1 - (this.tick - fadeStart) / (this.maxTick - fadeStart));
  };

  Piece.prototype.draw = function () {
    ctx.save();
    ctx.globalAlpha = this.alpha;
    ctx.translate(this.x, this.y);
    ctx.rotate(this.rot);
    ctx.fillStyle = this.color;
    if (this.shape === 'circle') {
      ctx.beginPath();
      ctx.arc(0, 0, this.h, 0, Math.PI * 2);
      ctx.fill();
    } else {
      ctx.fillRect(-this.w / 2, -this.h / 2, this.w, this.h);
    }
    ctx.restore();
  };

  /* ── Burst ── */
  function burst() {
    var now = Date.now();
    if (now - lastBurst < 1000) return;
    lastBurst = now;

    ensureDialog();
    cvs.width = window.innerWidth;
    cvs.height = document.documentElement.clientHeight || window.innerHeight;

    if (!dlg.open) {
      try { dlg.showModal(); } catch (e) {}
    }

    pieces = [];
    var count = Math.max(80, Math.min(160, Math.floor(window.innerWidth / 9)));
    for (var i = 0; i < count; i++) {
      pieces.push(new Piece(true));
      pieces.push(new Piece(false));
    }
    if (!raf) loop();
  }

  function loop() {
    ctx.clearRect(0, 0, cvs.width, cvs.height);
    pieces = pieces.filter(function (p) {
      p.step();
      p.draw();
      return p.alpha > 0;
    });
    if (pieces.length) {
      raf = requestAnimationFrame(loop);
    } else {
      raf = null;
      if (dlg && dlg.open) dlg.close();
    }
  }

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
